import { render, staticRenderFns } from "./DateRule.vue?vue&type=template&id=49184058&scoped=true&"
import script from "./DateRule.vue?vue&type=script&lang=ts&"
export * from "./DateRule.vue?vue&type=script&lang=ts&"
import style0 from "./DateRule.vue?vue&type=style&index=0&id=49184058&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49184058",
  null
  
)

export default component.exports